export class Region {
  id: number;
  name!: string;
  sigla!: string;

  constructor(dto?: Partial<Region>) {
    Object.assign(this, dto);
  }
}
